import { render, staticRenderFns } from "./pendingReceipt.vue?vue&type=template&id=644778ba&scoped=true&"
import script from "./pendingReceipt.vue?vue&type=script&lang=js&"
export * from "./pendingReceipt.vue?vue&type=script&lang=js&"
import style0 from "./pendingReceipt.vue?vue&type=style&index=0&id=644778ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644778ba",
  null
  
)

export default component.exports